import { VuexState, WPPost, WPMenu, WPCategory } from '@/common/RiskResources';
import RiskResources from '@/services/RiskResources';

import Brand from '@/services/Brand';

import axios from 'axios';

const state: VuexState = {
     loading: false,
     error: false,
     notFound: false,
     page: undefined,
     categories: undefined,
     menu: undefined,
     menu_location: undefined,
     post_type: undefined,
     posts: undefined,
     claim_reviews: undefined,
     clinical_specialty: undefined,
     risk_management_issue: undefined,
     webinars: undefined,
     webinar_categories: undefined,
};

const getters = {
     pageTemplate(state: VuexState): string {
          if (state.page === undefined) {
               return undefined;
          }

          return state.page.template;
     },
     pageTitle(state: VuexState) {
          if (state.page === undefined) {
               return undefined;
          }

          return state.page.title.rendered;
     },
     pageContent(state: VuexState) {
          if (state.page === undefined) {
               return undefined;
          }

          const acf = state.page.acf.brand;
          if (acf === false || acf === null || acf === undefined) {
               return undefined;
          }

          const brand = Brand.getBrand();
          const findBrandContent = acf.filter(b => brand === b.brand);

          if (findBrandContent.length > 0) {
               return findBrandContent[0];
          }

          const getGlobalConttent = acf.filter(b => b.brand === 'global');

          return getGlobalConttent[0];
     },
     claimReviews(state: VuexState) {
          return state.claim_reviews;
     },
     claimReview(state: VuexState) {
          return (slug): WPPost => {
               return state.claim_reviews.find(review => slug === review.slug) || undefined;
          };
     },
};

const mutations = {
     clearData(state: VuexState) {
          state.page = undefined;
          state.error = false;
          state.loading = false;
          state.notFound = false;
     },
     setLoading(state: VuexState, loading: boolean) {
          state.loading = loading;
     },
     setNotFound(state: VuexState, notFound: boolean) {
          state.notFound = notFound;
     },
     setError(state: VuexState, error: boolean) {
          state.error = error;
     },
     setPage(state: VuexState, payload: WPPost) {
          state.page = payload;
     },
     setPostType(state: VuexState, payload: string) {
          state.post_type = payload;
     },
     setMenu(state: VuexState, payload: WPMenu) {
          state.menu = payload;
     },
     setMenuLocation(state: VuexState, payload: string) {
          state.menu_location = payload;
     },
     setClaimReviews(state: VuexState, payload: WPPost[]) {
          state.claim_reviews = payload;
     },
     setClinicalSpecialty(state: VuexState, payload: WPCategory[]) {
          state.clinical_specialty = payload;
     },
     setRiskManagementIssue(state: VuexState, payload: WPCategory[]) {
          state.risk_management_issue = payload;
     },
     setCategories(state: VuexState, payload: WPCategory[]) {
          state.categories = payload;
     },
     setPosts(state: VuexState, payload: WPPost[]) {
          state.posts = payload;
     },
     setWebinarCategories(state: VuexState, payload: WPCategory[]) {
          state.webinar_categories = payload;
     },
     setOnDemandWebinars(state: VuexState, payload: WPPost[]) {
          state.webinars = payload;
     },
};

const actions = {
     async clearData({ commit }: any): Promise<void> {
          commit('clearData');
     },
     async getPage({ commit, state }: any, pageSlug: string): Promise<void> {
          try {
               commit('setLoading', true);
               commit('setError', false);
               commit('setNotFound', false);
               const slug: string = RiskResources.getSlug(pageSlug);

               // @ts-ignore
               const getRequest = axios({
                    method: 'GET',
                    request: 'page',
                    url: process.env.VUE_APP_WORDPRESS_API + '/wp-json/wp/v2/pages?slug=' + slug,
                    skipAuth: true,
               });

               const menuName: string = RiskResources.getSidebarSlug(pageSlug);
               let getMenu: any;
               if (menuName !== undefined && state.menu_location !== menuName) {
                    // @ts-ignore
                    getMenu = axios({
                         method: 'GET',
                         request: 'menu',
                         url:
                              process.env.VUE_APP_WORDPRESS_API +
                              '/wp-json/wp-api-menus/v2/menu-locations/' +
                              menuName,
                         skipAuth: true,
                    });
               }

               const promises = await Promise.all([getRequest, getMenu]);
               const removeUndefined = promises.filter(item => item !== undefined);

               console.log(removeUndefined);
               let page;
               let menu;
               if (removeUndefined.length === 1) {
                    page = removeUndefined[0];
               } else if (removeUndefined.length === 2) {
                    page = removeUndefined.filter(item => item.config.request === 'page')[0];
                    menu = removeUndefined.filter(item => item.config.request === 'menu')[0];
               }

               if (menu !== undefined) {
                    commit('setMenu', menu.data);
                    commit('setMenuLocation', menuName);
               } else if (menu === undefined && state.menu_location !== menuName) {
                    commit('setMenu', undefined);
                    commit('setMenuLocation', undefined);
               }

               if (page.data.length > 0 && RiskResources.brandHasAccess(page.data[0])) {
                    commit('setPage', page.data[0]);
                    commit('setPostType', 'page');
               } else {
                    commit('setPage', undefined);
                    commit('setNotFound', true);
               }

               return;
          } catch (e) {
               console.log(e);
               commit('setPage', undefined);
               commit('setError', true);
               commit('setPostType', undefined);
          } finally {
               commit('setLoading', false);
          }
     },
     async getClaimReviews({ commit, state }: any): Promise<void> {
          if (Array.isArray(state.claim_reviews) && state.claim_reviews.length === 0) {
               return;
          }

          try {
               commit('setLoading', true);
               commit('setError', false);
               commit('setNotFound', false);

               // @ts-ignore
               const getRequest = axios({
                    method: 'GET',
                    request: 'claim_reviews',
                    url:
                         process.env.VUE_APP_WORDPRESS_API +
                         '/wp-json/wp/v2/claim_reviews?per_page=100',
                    skipAuth: true,
               });

               let getClinicalSpecialty;
               if (state.clinical_specialty === undefined) {
                    // @ts-ignore
                    getClinicalSpecialty = axios({
                         method: 'GET',
                         request: 'clinical_specialty',
                         url:
                              process.env.VUE_APP_WORDPRESS_API +
                              '/wp-json/wp/v2/clinical_specialty?per_page=100',
                         skipAuth: true,
                    });
               }

               let getRiskManagementIssue;
               if (state.risk_management_issue === undefined) {
                    // @ts-ignore
                    getRiskManagementIssue = axios({
                         method: 'GET',
                         request: 'risk_management_issue',
                         url:
                              process.env.VUE_APP_WORDPRESS_API +
                              '/wp-json/wp/v2/risk_management_issue?per_page=100',
                         skipAuth: true,
                    });
               }

               const [page, clinicalSpecialty, riskManagementIssue] = await Promise.all([
                    getRequest,
                    getClinicalSpecialty,
                    getRiskManagementIssue,
               ]);

               if (clinicalSpecialty !== undefined && clinicalSpecialty.data.length > 0) {
                    commit('setClinicalSpecialty', clinicalSpecialty.data);
               }

               if (riskManagementIssue !== undefined && riskManagementIssue.data.length > 0) {
                    commit('setRiskManagementIssue', riskManagementIssue.data);
               }

               if (page.data !== undefined) {
                    commit('setClaimReviews', page.data);
                    commit('setPostType', 'claim_reviews');
               } else {
                    commit('setNotFound', true);
                    commit('setPostType', undefined);
               }

               commit('setPage', undefined);

               return;
          } catch (e) {
               console.log(e);
               commit('setPage', undefined);
               commit('setError', true);
          } finally {
               commit('setLoading', false);
          }
     },
     async getClaimReview({ commit, state }: any, pageSlug: string): Promise<void> {
          if (state.claim_reviews === undefined || state.claim_reviews.length <= 0) {
               await actions.getClaimReviews({ commit, state });
          }

          commit('setLoading', true);
          commit('setError', false);
          commit('setNotFound', false);

          const slug: string = RiskResources.getSlug(pageSlug);

          const page = state.claim_reviews.find(review => slug === review.slug) || undefined;

          if (page !== undefined) {
               commit('setPage', page);
               commit('setPostType', 'claim_reviews');
          } else {
               commit('setPage', undefined);
               commit('setError', true);
               commit('setPostType', undefined);
          }

          commit('setLoading', false);
     },
     async getNewsArticles({ commit, state }: any): Promise<void> {
          if (Array.isArray(state.posts) && state.posts.length === 0) {
               return;
          }

          try {
               commit('setLoading', true);
               commit('setError', false);
               commit('setNotFound', false);

               // @ts-ignore
               const getRequest = axios({
                    method: 'GET',
                    request: 'posts',
                    url:
                         process.env.VUE_APP_WORDPRESS_API +
                         '/wp-json/wp/v2/posts?per_page=100&status=publish,future',
                    skipAuth: true,
                    headers: {
                         Authorization: 'Basic ' + btoa('APIREQUEST:P2iCV7#mWULkpLmzyB6fFCv('),
                    },
               });

               let getCategories;
               if (state.categories === undefined) {
                    // @ts-ignore
                    getCategories = axios({
                         method: 'GET',
                         request: 'cateogires',
                         url:
                              process.env.VUE_APP_WORDPRESS_API +
                              '/wp-json/wp/v2/categories?per_page=100',
                         skipAuth: true,
                    });
               }

               const [posts, categories] = await Promise.all([getRequest, getCategories]);

               if (categories !== undefined && categories.data.length > 0) {
                    commit('setCategories', categories.data);
               }

               if (posts.data !== undefined) {
                    commit('setPosts', posts.data);
                    commit('setPostType', 'posts');
               } else {
                    commit('setNotFound', true);
                    commit('setPostType', undefined);
               }

               commit('setPage', undefined);

               return;
          } catch (e) {
               console.log(e);
               commit('setPage', undefined);
               commit('setError', true);
          } finally {
               commit('setLoading', false);
          }
     },
     async getNewsArticle({ commit, state }: any, pageSlug: string): Promise<void> {
          if (state.posts === undefined || state.posts.length <= 0) {
               await actions.getNewsArticles({ commit, state });
          }

          commit('setLoading', true);
          commit('setError', false);
          commit('setNotFound', false);

          const slug: string = RiskResources.getSlug(pageSlug);

          const page = state.posts.find(post => slug === post.slug) || undefined;

          if (page !== undefined) {
               commit('setPage', page);
               commit('setPostType', 'posts');
          } else {
               commit('setPage', undefined);
               commit('setError', true);
               commit('setPostType', undefined);
          }

          commit('setLoading', false);
     },
     async getOnDemandWebinars({ commit, state }: any): Promise<void> {
          if (Array.isArray(state.webinars) && state.webinars.length === 0) {
               return;
          }

          try {
               commit('setLoading', true);
               commit('setError', false);
               commit('setNotFound', false);

               // @ts-ignore
               const getRequest = axios({
                    method: 'GET',
                    request: 'posts',
                    url:
                         process.env.VUE_APP_WORDPRESS_API +
                         '/wp-json/wp/v2/on_demand_webinars?per_page=100',
                    skipAuth: true,
               });

               let getCategories;
               if (state.categories === undefined) {
                    // @ts-ignore
                    getCategories = axios({
                         method: 'GET',
                         request: 'cateogires',
                         url:
                              process.env.VUE_APP_WORDPRESS_API +
                              '/wp-json/wp/v2/webinar_categories?per_page=100',
                         skipAuth: true,
                    });
               }

               const [posts, categories] = await Promise.all([getRequest, getCategories]);

               if (categories !== undefined && categories.data.length > 0) {
                    commit('setWebinarCategories', categories.data);
               }

               if (posts.data !== undefined) {
                    commit('setOnDemandWebinars', posts.data);
                    commit('setPostType', 'webinars');
               } else {
                    commit('setNotFound', true);
                    commit('setPostType', undefined);
               }

               commit('setPage', undefined);

               return;
          } catch (e) {
               console.log(e);
               commit('setPage', undefined);
               commit('setError', true);
          } finally {
               commit('setLoading', false);
          }
     },
     async getOnDemandWebinar({ commit, state }: any, pageSlug: string): Promise<void> {
          if (state.webinars === undefined || state.webinars.length <= 0) {
               await actions.getOnDemandWebinars({ commit, state });
          }

          console.log('here?');

          commit('setLoading', true);
          commit('setError', false);
          commit('setNotFound', false);

          const slug: string = RiskResources.getSlug(pageSlug);
          console.log(slug);
          const page = state.webinars.find(post => slug === post.slug) || undefined;

          console.log(page);

          if (page !== undefined) {
               commit('setPage', page);
               commit('setPostType', 'webinars');
          } else {
               commit('setPage', undefined);
               commit('setError', true);
               commit('setPostType', undefined);
          }

          commit('setLoading', false);
     },
};

export { state, getters, mutations, actions };
